<template>
  <div>
    <notification-message
      v-if="!fromTeacher"
      iconClass="el-icon-check"
      :message="$t('company.setup_company.successfully_created')"
    />

    <div class="content">
      <onboarding-options-picker
        :options="pickerOptions"
        :title="$t('company.setup_company.setup_your_company')"
        :subtitle="$t('company.setup_company.invite_students_teachers')"
        :buttonText="$t('company.setup_company.continue')"
        @continueEvent="setupCompany"
      />
    </div>
  </div>
</template>

<script>
  import NotificationMessage from '@/components/common/NotificationMessage'
  import OnboardingOptionsPicker from '@/components/common/OnboardingOptionsPicker'

  export default {
    components: {
      NotificationMessage,
      OnboardingOptionsPicker
    },
    data() {
      return {
        pickerOptions: [
          {
            input: 'class',
            image: 'create-class.svg',
            name: this.$t('company.setup_company.create_class')
          },
          {
            input: 'teacher',
            image: 'teacher.svg',
            name: this.$t('company.setup_company.invite_teachers'),
          },
          {
            input: 'student',
            image: 'invite-students.svg',
            name: this.$t('company.setup_company.invite_students')
          }
        ]
      }
    },
    mounted() {
      // TODO: this need to be changed
      this.$store.dispatch('user/loadUserData')
    },
    methods: {
      setupCompany() {
      }
    },
  }
</script>

<style lang="scss" scoped>

  .content {
    display: table;
    margin: 0 auto;
    margin-top: 48px;
  }
</style>
